import i18n from "@/i18n";
import { AdminRoutes } from "@/data/enums/router";

export function catalogueTabigation() {
  return [
    {
      label: i18n.t("_.products"),
      to: {
        name: `adminCatalogueProducts`
      }
    },
    {
      label: i18n.t("_.options"),
      to: {
        name: `adminCatalogueOptions`
      }
    },
    {
      label: i18n.t("_.attributes"),
      to: {
        name: `adminCatalogueAttributes`
      }
    }
  ];
}

export const productOverview = vm => [
  {
    label: i18n.t("_.product_details"),
    to: (vm: any) => {
      return {
        name: "adminCatalogueProductDetails",
        params: vm.$route.params
      };
    }
  },
  {
    label: i18n.t("_.product_billing"),
    to: (vm: any) => {
      return {
        name: "adminCatalogueProductBilling",
        params: vm.$route.params
      };
    },
    hasWarning: vm.hasMissingPrices,
    hasError: vm.routeHasError
  },
  {
    label: i18n.t("_.product_automation"),
    to: (vm: any) => {
      return {
        name: "adminCatalogueProductAutomation",
        params: vm.$route.params
      };
    },
    if: () => {
      return vm.canShowAutomation;
    }
  },
  {
    label: i18n.t("_.product_options"),
    to: (vm: any) => {
      return {
        name: "adminCatalogueProductOptions",
        params: vm.$route.params
      };
    }
  },
  {
    label: i18n.t("_.product_attributes"),
    to: (vm: any) => {
      return {
        name: "adminCatalogueProductAttributes",
        params: vm.$route.params
      };
    }
  },
  {
    label: i18n.t("_.provisioning"),
    to: (vm: any) => {
      return {
        name: "adminCatalogueProductProvisioning",
        params: vm.$route.params
      };
    },
    if: () => {
      return vm.canShowProvisioning;
    }
  },
  {
    label: i18n.t("_.upgrades_downgrades"),
    to: (vm: any) => {
      return {
        name: "admin__catalogueProductUpgradeDowngrade",
        params: vm.$route.params
      };
    },
    if: () => {
      return vm.canShowUpgradesDowngrades;
    }
  },
  {
    label: i18n.tc("_.recommendations", 2),
    to: (vm: any) => {
      return {
        name: "adminCatalogueProductRecommendations",
        params: vm.$route.params
      };
    },
    if: () => {
      return vm.canShowRecommendations;
    }
  },

  {
    label: i18n.t("_.product_notifications"),
    to: (vm: any) => {
      return {
        name: "adminCatalogueProductNotifications",
        params: vm.$route.params
      };
    },
    if: (vm: any) => vm.$userCan("list_object_notification_mappings")
  },
  {
    label: i18n.t("_.client_area_templates"),
    to: (vm: any) => {
      return {
        name: "admin__catalogueProductTemplates",
        params: vm.$route.params
      };
    }
  },
  {
    label: i18n.t("_.insights"),
    to: (vm: any) => {
      return {
        name: "adminCatalogueProductContractProducts",
        params: vm.$route.params
      };
    },
    children: [
      {
        label: i18n.t("_.products_and_services"),
        to: (vm: any) => {
          return {
            name: "adminCatalogueProductContractProducts",
            params: vm.$route.params
          };
        }
      }
    ],
    if: () => {
      return vm.canShowContractProducts;
    }
  }
];

export const categoryOverview = vm => [
  {
    label: i18n.t("_.category_details"),
    to: (vm: any) => {
      return {
        name: "adminCatalogueCategoryDetails",
        params: vm.$route.params
      };
    }
  },
  {
    label: i18n.t("_.category_products"),
    to: (vm: any) => {
      return {
        name: "adminCatalogueCategoryProducts",
        params: vm.$route.params
      };
    }
  },
  {
    label: i18n.t("_.provisioning"),
    to: (vm: any) => {
      return {
        name: "adminCatalogueCategoryProvisioning",
        params: vm.$route.params
      };
    },
    if: () => {
      return vm.canShowProvisioning;
    }
  }
];

export const optionCategoryOverview = () => [
  {
    label: i18n.t("_.category_details"),
    to: (vm: any) => {
      return {
        name: "adminCatalogueOptionCategoryDetails",
        params: vm.$route.params
      };
    }
  },
  {
    label: i18n.t("_.category_options"),
    to: (vm: any) => {
      return {
        name: "adminCatalogueOptionCategoryProducts",
        params: vm.$route.params
      };
    }
  }
];

export const attributeCategoryOverview = () => [
  {
    label: i18n.t("_.category_details"),
    to: (vm: any) => {
      return {
        name: "adminCatalogueAttributeCategoryDetails",
        params: vm.$route.params
      };
    }
  },
  {
    label: i18n.t("_.category_attributes"),
    to: (vm: any) => {
      return {
        name: "adminCatalogueAttributeCategoryProducts",
        params: vm.$route.params
      };
    }
  }
];

export const productOptionOverview = () => [
  {
    label: i18n.t("_.product_option_details"),
    to: (vm: any) => {
      return {
        name: "adminCatalogueOptionDetails",
        params: vm.$route.params
      };
    }
  },
  {
    label: i18n.t("_.product_option_billing"),
    to: (vm: any) => {
      return {
        name: "adminCatalogueOptionBilling",
        params: vm.$route.params
      };
    }
  }
];

export const productAttributeOverview = () => [
  {
    label: i18n.t("_.product_attribute_details"),
    to: (vm: any) => {
      return {
        name: "adminCatalogueAttributeDetails",
        params: vm.$route.params
      };
    }
  }
];

export const productsQuickFilters = [
  {
    label: "_.all_products_and_bundles",
    to: {
      name: `adminCatalogueProducts`
    }
  }
];

export const productOptionsQuickFilters = [
  {
    label: "_.all_product_options",
    to: {
      name: `adminCatalogueOptions`
    }
  }
];

export const productAttributesQuickFilters = [
  {
    label: "_.all_product_attributes",
    to: {
      name: `adminCatalogueAttributes`
    }
  }
];

export function CatalogueProductTemplatesTabigation() {
  return [
    {
      label: i18n.t("_.slots"),
      to: {
        name: `admin__catalogueProductTemplateSlots`
      }
    },
    {
      label: i18n.t("_.templates"),
      to: {
        name: `admin__catalogueProductTemplateTemplates`
      }
    }
  ];
}

export const catalogueProductsCPsTabigation = () => [
  {
    label: i18n.t("_.all"),
    to: () => {
      return {
        name: AdminRoutes.CATALOGUE_PRODUCT_ALL_CPS
      };
    }
  },
  {
    label: i18n.t("_.active"),
    to: () => {
      return {
        name: AdminRoutes.CATALOGUE_PRODUCT_ACTIVE_CPS
      };
    }
  },
  {
    label: i18n.t("_.cancelled"),
    to: () => {
      return {
        name: AdminRoutes.CATALOGUE_PRODUCT_CANCELLED_CPS
      };
    }
  }
];
